<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/casa-ferreirinha')">Casa Ferreirinha
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/howards-folly')">Howard’s Folly
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/prats-and-symington')">Prats and
                        Symington (Chryseia)
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-crasto')">Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vale-meao')">Quinta Do Vale
                        Meao
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vallado')">Quinta Do Vallado
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vesuvio')">Quinta Do Vesuvio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/roquette-cazes-quinta')">Roquette
                        &amp; Cazes — Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/symington')">Symington
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vesuvio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Se pensi che il vino Porto fosse solo per il tagliere di formaggi natalizi, allora è tempo di ripensarci.
                        Tornano rapidamente in auge sia sulla cena che sulle tavole dei vini investibili, alcuni Ports (o Portos, o
                        I vini di Porto, è la stessa cosa) in particolare richiedono attenzione più di una volta all'anno. Quinta
                        Do Vesuvio è una di queste meraviglie.
                    </div>

                    <div class="howto-title2">Un porto che vale più del nostro tempo</div>
                    <div class="howto-text">
                        La quintessenza di tutti i vini di Porto, Quinta do Vesuvio gode di una reputazione di leader da oltre un secolo. La tenuta stessa risale al 1565, ma fu solo nel XIX secolo che iniziò davvero a mettere le ali. Il motivo era una donna: Dona Antónia Adelaide Ferreira. UN
                        formidabile signora che ha preso il controllo delle proprietà della sua famiglia dopo la sua vedovanza a soli 33 anni,
                        Ferreirinha (il suo soprannome datole dal suo staff), si è dedicata alla gestione di
                        Quinta Do Vesuvio. La sua meticolosa dedizione ha alzato il livello di tutti i vini di Porto e il suo visionario
                        le prospettive devono ancora essere eguagliate. Tuttavia, senza un vero erede per gestire la tenuta con il
                        stessa quantità di passione di Ferreirinha, Quita Do Vesuvio iniziò a scivolare. La proprietà è stata venduta a
                        la famiglia Symington nel 1989, la cui lunga storia (13 generazioni) nel Douro dal 17
                        secolo, sembrava una scelta naturale per riportare alla perfezione il Porto, un tempo leggendario. IL
                        La famiglia Symington possiede altre 25 quintas, per un totale di 940 ettari in totale (Quinta do
                        Vesuvio è la più grande delle proprietà, a 326 ettari).
                    </div>

                    <div class="howto-title2">Una delle tenute più belle della Valle del Douro</div>
                    <div class="howto-text">
                        Situata a soli 20 chilometri dalla Spagna, la posizione privilegiata di Quinta do Vesuvio conferma l'adagio
                        che più in alto si sale nella valle, migliore è la qualità del vino. La tenuta è
                        l'enormità e l'altitudine (dai 100 ai 460 metri), insieme alla diversa età della vite (dai
                        dagli anni '70 a prima della seconda guerra mondiale) significa che i porti di Quinta do Vesuvio sono ricchi, diversificati e complessi.
                        Inoltre, i Symington hanno mantenuto le cose tradizionali, preservando il metodo secolare
                        di pigiare l'uva in 1827 lagares di granito. Oggi il Vesuvio è una delle ultime valli del Douro
                        proprietà per mantenere questa tradizione.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vesuvio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn Sie glauben, dass Portwein nur für die Weihnachtskäseplatte gedacht war, dann ist es an der Zeit, noch einmal darüber nachzudenken.
                        Einige Portweine (oder Portos, oder …) feiern schnell ein Comeback sowohl auf dem Esstisch als auch auf den investierbaren Weintischen
                        Insbesondere die Weine aus Porto (das ist alles das Gleiche) brauchen mehr als einmal im Jahr Aufmerksamkeit. Quinta
                        Do Vesuvio ist ein solches Wunder.
                    </div>

                    <div class="howto-title2">Ein Portwein, der mehr als nur unsere Zeit wert ist</div>
                    <div class="howto-text">
                        Quinta do Vesuvio ist der Inbegriff aller Portweine und genießt seit über einem Jahrhundert den Ruf eines Spitzenweins. Das Anwesen selbst stammt aus dem Jahr 1565, aber erst im 19. Jahrhundert begann es so richtig aufzublühen. Der Grund war eine Frau – Dona Antónia Adelaide Ferreira. A
                        beeindruckende Dame, die nach ihrer Witwenschaft im Alter von nur 33 Jahren die Kontrolle über den Besitz ihrer Familie übernahm,
                        Ferreirinha (ihr Spitzname wurde ihr von ihren Mitarbeitern gegeben) widmete sich der Leitung von
                        Quinta Do Vesuvio. Ihre akribische Hingabe hat die Messlatte für alle Portweine und ihren Visionär höher gelegt
                        Die Aussichten sind noch nicht erreicht. Allerdings gibt es keinen wirklichen Erben, der den Nachlass verwalten könnte
                        Mit der gleichen Leidenschaft wie Ferreirinha geriet Quita Do Vesuvio ins Rutschen. Das Anwesen wurde verkauft
                        Die Familie Symington wurde 1989 gegründet und hat eine lange Geschichte (13 Generationen) im Douro seit dem 17. Jahrhundert
                        Jahrhundert schien es eine natürliche Ergänzung zu sein, den einst legendären Hafen wieder in Perfektion zu bringen. Der
                        Die Familie Symington besitzt 25 weitere Quintas, also insgesamt 940 Hektar (Quinta do
                        Vesuvio ist mit 326 Hektar das größte der Grundstücke.
                    </div>

                    <div class="howto-title2">Eines der schönsten Anwesen im Douro-Tal</div>
                    <div class="howto-text">
                        Die privilegierte Lage von Quinta do Vesuvio ist nur 20 Kilometer von Spanien entfernt und beweist dieses Sprichwort
                        Je weiter man im Tal hinauffährt, desto besser ist die Qualität des Weins. Das Anwesen
                        Die enorme Größe und Höhenlage (von 100 bis 460 Metern) sowie das unterschiedliche Alter der Reben (von
                        (1970er Jahre bis vor dem Zweiten Weltkrieg) bedeutet, dass die Häfen der Quinta do Vesuvio reichhaltig, vielfältig und komplex sind.
                        Darüber hinaus haben die Symingtons die Tradition beibehalten und die jahrhundertealte Methode beibehalten
                        des Tretens der Trauben in Granit-Lagares von 1827. Heute ist der Vesuv eines der letzten Douro-Täler
                        Eigenschaften, um diese Tradition aufrechtzuerhalten.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vesuvio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Si vous pensez que le vin de Porto n'était que pour le plateau de fromages de Noël, il est temps de réfléchir à nouveau.
                        Faisant un retour rapide sur les tables du dîner et des vins à investir, certains portos (ou portos, ou
                        Les vins de Porto, c'est la même chose) en particulier ont besoin d'attention plus d'une fois par an. Quinta
                        Do Vesuvio est l'une de ces merveilles.
                    </div>

                    <div class="howto-title2">Un porto qui vaut plus que notre temps</div>
                    <div class="howto-text">
                        La quintessence de tous les vins de Porto, Quinta do Vesuvio jouit d'une réputation de leader depuis plus d'un siècle. Le domaine lui-même date de 1565, mais ce n'est qu'au XIXe siècle qu'il a vraiment commencé à pousser des ailes. La raison en était une femme - Dona Antónia Adelaide Ferreira. UN
                        redoutable dame qui a pris le contrôle des biens de sa famille dès son veuvage à seulement 33 ans,
                        Ferreirinha (surnom que lui donnaient ses collaborateurs), se consacra à la gestion de
                        Quinta Do Vesuvio. Son dévouement méticuleux a élevé la barre sur tous les vins de Porto et son visionnaire
                        les perspectives n'ont pas encore été égalées. Cependant, sans véritable héritier pour gérer le domaine avec
                        même quantité de passion que Ferreirinha, Quita Do Vesuvio a commencé à glisser. Le domaine a été vendu à
                        la famille Symington en 1989, dont la longue histoire (13 générations) dans le Douro depuis le 17ème
                        siècle, semblait un choix naturel pour restaurer à la perfection le port autrefois légendaire. Le
                        La famille Symington possède 25 autres quintas, soit un total de 940 hectares au total (Quinta do
                        Le Vésuve est la plus grande des propriétés, avec 326 hectares).
                    </div>

                    <div class="howto-title2">L'un des plus beaux domaines de la vallée du Douro</div>
                    <div class="howto-text">
                        Situé à seulement 20 kilomètres de l'Espagne, l'emplacement privilégié de Quinta do Vesuvio prouve l'adage
                        que plus on monte dans la vallée, meilleure est la qualité du vin. Le domaine
                        l'énormité et la rage d'altitude (de 100 à 460 mètres), ainsi que l'âge variable de la vigne (de
                        des années 1970 à l'avant-guerre) signifie que les ports de Quinta do Vesuvio sont riches, diversifiés et complexes.
                        De plus, les Symington ont gardé les choses traditionnelles, préservant la méthode séculaire
                        de fouler le raisin dans les lagares de granit de 1827. Aujourd'hui, le Vésuve est l'une des dernières vallées du Douro
                        propriétés pour maintenir cette tradition.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vesuvio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        If you think that Port wine was just for the Christmas cheeseboard then its time to think again.
                        Fast making a comeback on both the dinner and investable wine tables, some Ports (or Portos, or
                        Porto wines, its all the same thing) in particular need attention more than once a year. Quinta
                        Do Vesuvio is one such wonder.
                    </div>

                    <div class="howto-title2">A port wine worth more than just our time</div>
                    <div class="howto-text">
                        The quintessential of all Port wines, Quinta do Vesuvio has enjoyed a reputation as a leader for over a century. The estate itself dates back to 1565, but it wasn’t until the 19th century that it really began to grow wings. The reason was one woman - Dona Antónia Adelaide Ferreira. A
                        formidable lady who took control of her family’s estates upon her widowhood aged just 33,
                        Ferreirinha (her nickname given to her by her staff), devoted herself to the management of
                        Quinta Do Vesuvio. Her meticulous dedication raised the bar on all Port wines and her visionary
                        outlook has yet to be equalled. However, with no real inheritor to manage the estate with the
                        same amount of passion as Ferreirinha, Quita Do Vesuvio began to slide. The estate was sold to
                        the Symington family in 1989, whose long history (13-generations) in the Douro since the 17th
                        century, seemed a natural fit to restore the once legendary Port back to perfection. The
                        Symington family own 25 other quintas, making a total of 940-hectares in total (Quinta do
                        Vesuvio is the largest of the properties, at 326 hectacres).
                    </div>

                    <div class="howto-title2">One of the loveliest estates in the Douro Valley</div>
                    <div class="howto-text">
                        Located just 20 kilometres from Spain, Quinta do Vesuvio’s privileged location proves the adage
                        that the higher up the valley you travel, the better the quality of the wine. The estate’s
                        enormity and altitude rage (from 100 to 460 metres), along with the varying age of vine (from
                        the 1970s to pre-WWII) means that Ports from Quinta do Vesuvio are rich, diverse and complex.
                        Additionally, the Symingtons have kept things traditional, preserving the centuries-old method
                        of treading the grapes in 1827 granite lagares. Today Vesuvio is one of the last Douro Valley
                        properties to maintain this tradition.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "QuintaDoVesuvio",
    data() {
        return {
            select: {report: 'Quinta Do Vesuvio', src: '/wine-guide/portugal/douro-valley/quinta-do-vesuvio'},
            items: [
                {report: 'Casa Ferreirinha', src: '/wine-guide/portugal/douro-valley/casa-ferreirinha'},
                {report: 'Howard’s Folly', src: '/wine-guide/portugal/douro-valley/howards-folly'},
                {
                    report: 'Prats and Symington (Chryseia)',
                    src: '/wine-guide/portugal/douro-valley/prats-and-symington'
                },
                {report: 'Quinta do Crasto', src: '/wine-guide/portugal/douro-valley/quinta-do-crasto'},
                {report: 'Quinta Do Vale Meao', src: '/wine-guide/portugal/douro-valley/quinta-do-vale-meao'},
                {report: 'Quinta Do Vallado', src: '/wine-guide/portugal/douro-valley/quinta-do-vallado'},
                {report: 'Quinta Do Vesuvio', src: '/wine-guide/portugal/douro-valley/quinta-do-vesuvio'},
                {
                    report: 'Roquette & Cazes — Quinta do Crasto',
                    src: '/wine-guide/portugal/douro-valley/roquette-cazes-quinta'
                },
                {report: 'Symington', src: '/wine-guide/portugal/douro-valley/symington'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Quinta Do Vesuvio | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich and diverse flavors of the Douro Valley with Quinta Do Vesuvio, a premier wine producer known for producing exceptional red and fortified wines. Experience the traditional winemaking techniques and terroir of the region with each sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
